<script setup>
import { useAppStore } from '~/store/main'

// Props
const props = defineProps({
  layer: { type: Number, default: 0 },
  id: { type: String, default: '' },
})

// Store
const store = useAppStore()
const {
  getRootMenu,
  getStudiumNav,
  getAcademyNav,
  getProgramNav,
  getStudiumNavByID,
  getAcademyNavByID,
  getProgramNavByID,
} = storeToRefs(store)

// Refs
const firstLink = ref({})
const otherLinks = ref([])
const show = ref(false)
const closeRef = ref(null)

const setLayer = () => {
  show.value = false
  switch (props.layer) {
    case 0: {
      // STUDY
      firstLink.value = getStudiumNav.value[0]
      const studiumNav = [...getStudiumNav.value]
      studiumNav.shift()
      otherLinks.value = studiumNav
      break
    }
    case 1: {
      // ACADEMY
      firstLink.value = getAcademyNav.value[0]
      const academyNav = [...getAcademyNav.value]
      academyNav.shift()
      otherLinks.value = academyNav
      break
    }
    case 2: {
      // PROGRAM
      firstLink.value = getProgramNav.value[0]
      const programNav = [...getProgramNav.value]
      programNav.shift()
      otherLinks.value = programNav
      break
    }
    case 3: // NEXT LEVEL OF NAVIGATION
      firstLink.value = []
      if (getRootMenu.value === 'studium') {
        otherLinks.value = getStudiumNavByID.value(props.id)
      }
      if (getRootMenu.value === 'akademie') {
        otherLinks.value = getAcademyNavByID.value(props.id)
      }
      if (getRootMenu.value === 'program') {
        otherLinks.value = getProgramNavByID.value(props.id)
      }
      break
  }

  setTimeout(() => {
    show.value = true
    closeRef.value?.scrollIntoView(false)
  }, 100)
}

onMounted(() => {
  setLayer()
  document.body.style.overflow = 'hidden'
})

onUnmounted(() => {
  document.body.style.overflow = ''
})

watch(
  () => props.layer,
  () => {
    setLayer()
  }
)
</script>

<template>
  <div v-if="otherLinks.length || Object.keys(otherLinks).length > 0">
    <div ref="closeRef" class="closeRow">
      <Close v-if="layer === 3" :back-menu="true" :back="false" />
      <Close v-else :back="false" />
    </div>
    <transition name="slider">
      <div v-if="show" class="slider">
        <h1 v-if="layer === 3 && otherLinks.label" class="is_c2 text_h1">
          {{ otherLinks.label }}
        </h1>
        <div
          v-if="layer === 3 && otherLinks && otherLinks.childItems"
          class="links"
        >
          <RowLink
            v-for="item in otherLinks.childItems.nodes"
            :id="item.id"
            :key="item.id"
            :label="item.label"
            :slug="
              item.connectedNode ? item.connectedNode.node.slug : item.path
            "
            :content-type="
              item.connectedNode
                ? item.connectedNode.node.contentType.node.name
                : ''
            "
            :root="getRootMenu"
            :navigation="true"
          />
        </div>
        <div v-else class="links">
          <RowLink
            v-for="item in otherLinks"
            :id="item.id"
            :key="item.id"
            :label="item.label"
            :slug="
              item.connectedNode ? item.connectedNode.node.slug : item.path
            "
            :content-type="
              item.connectedNode
                ? item.connectedNode.node.contentType
                  ? item.connectedNode.node.contentType.node.name
                  : item.connectedNode.node.taxonomy.node.name
                : ''
            "
            :root="getRootMenu"
            :navigation="true"
          />
          <div class="switcher">
            <LanguageSwitcher :root="getRootMenu" />
            <ThemeSwitcher />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  padding-top: 25.5px;
}

.closeRow {
  margin-bottom: 65px;
}

.button {
  margin: 30px auto;
}

.links {
  margin-bottom: 90px;
}

.slider {
  padding-bottom: 100px;
}

.slider-enter-active,
.slider-leave-active {
  transition:
    opacity 0.2s ease-in-out,
    transform 0.2s ease-in-out;
}

.slider-enter-from,
.slider-leave-to {
  opacity: 0;
  transform: translate3d(-1rem, 0, 0);
}

.switcher {
  margin-top: 100px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
}
</style>
